import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=cd6535a2&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6535a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd6535a2')) {
      api.createRecord('cd6535a2', component.options)
    } else {
      api.reload('cd6535a2', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=cd6535a2&scoped=true", function () {
      api.rerender('cd6535a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/account/edit.vue"
export default component.exports